import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from 'framer-motion';
import amplitude from "../utils/amplitude";

export default function AnalyzeScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const photo = location.state?.photo;

  useEffect(() => {
    if (!photo) {
      navigate('/');
    }

        if(process.env.NODE_ENV === "production"){
          amplitude.track('Analyze Selfie Screen Open');
        }

    
    const timer = setTimeout(() => {
      navigate('/identify');
    }, 4000);

    return () => clearTimeout(timer);
  }, [photo, navigate]);

  if (!photo) return null;

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.3 }}
      className="w-full h-screen flex justify-center items-center bg-black"
    >
      <div className="relative w-full max-w-md h-full bg-black flex items-center justify-center overflow-hidden">
        
        {/* Фото на заднем фоне */}
        <img
          src={photo || "/img36.png"}
          alt="Selfie"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* Текст "Analyzing..." */}
        <motion.h1
          className="absolute top-10 left-1/2 transform -translate-x-1/2 text-white text-lg sm:text-xl font-semibold z-10 text-shadow px-2 text-center"
          animate={{ opacity: [0, 1, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          Analyzing your selfie...
        </motion.h1>

        {/* Линия сканирования */}
        <motion.div
          className="absolute top-0 left-0 w-full h-full pointer-events-none z-10"
          animate={{ y: ["-100%", "100%", "-100%"] }}
          transition={{ duration: 3, ease: "linear", repeat: Infinity }}
        >
          <div className="absolute top-1/2 left-0 w-full h-1 sm:h-2 bg-white/80 shadow-lg" />
        </motion.div>

      </div>
    </motion.div>
  );
}
